import React from 'react';
import './App.css';


import Navbar from './components/Navbar';
import TopCampaignBar from './components/layout/TopCampaignBar';
import RoutePath from './routes/RoutePath';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const storedLang = localStorage.getItem("appLanguage");
    if (storedLang) {
      i18n.changeLanguage(storedLang);
      document.documentElement.lang = storedLang;
    } else {
      // Default to i18n detected or fallback
      document.documentElement.lang = i18n.language || 'en';
    }
  }, [i18n]);
  return (
    <div className="App min-h-screen bg-fecos-bg flex flex-col font-sans text-fecos-text selection:bg-fecos-accent/20 selection:text-fecos-text overflow-x-hidden">

      {/* Sayfa değişince yukarı çıksın */}
      <ScrollToTop />

      {/* Toast Messages */}
      <ToastContainer
        position="top-center"
        autoClose={1800}
        pauseOnHover={false}
      />

      {/* STICKY HEADER WRAPPER (Campaign + Navbar) */}
      <div className="sticky top-0 z-50 flex flex-col">
        <TopCampaignBar />
        <Navbar />
      </div>

      {/* Main Content Area */}
      <main className="flex-1 w-full relative z-0">
        <RoutePath />
      </main>

      {/* FOOTER */}
      <Footer />

    </div>
  );
}

export default App;
